import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import Button from "./Button";

const Header = styled.header`
  padding-bottom: 4rem;
  font-size: 12px;
  
  > div {
    height: 4rem;
    padding: 0 1rem;
    position: fixed;
    background-color: white;
    ${({ border }) => border && `border-bottom: 1px solid #ccc`}
    z-index: 100;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  h1 {
    margin: 0;
    font-size: 24px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 5.5rem;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const HeaderComponent = props => {
  return (
    <Header border={props.border}>
      <div>
        {props.backPath ? (
          <ButtonContainer>
            <Button
              onClick={() => props.history.push(props.backPath)}
              label="back"
              icon="chevron-left"
            />
          </ButtonContainer>
        ) : (
            <ButtonContainer />
          )}
        <Title>
          {props.subTitle && <span>{props.subTitle}</span>}
          <h2>{props.title}</h2>
        </Title>
        {props.rightComponent ? (
          <ButtonContainer style={{ justifyContent: 'flex-end' }}>{props.rightComponent}</ButtonContainer>
        ) : props.donePath ? (
          <ButtonContainer style={{ justifyContent: 'flex-end' }}>
            <Button style={{ fontSize: '16px', padding: '.5rem' }} onClick={() => props.history.push(props.donePath)} label="Done" />
          </ButtonContainer>
        ) : (
              <ButtonContainer />
            )}
      </div>
    </Header>
  );
};

export default withRouter(HeaderComponent);



// WEBPACK FOOTER //
// ./src/Components/Header.js